"use client";

import { PROJECTS } from "@/assets/static/data";
import ArrowBack from "@/assets/vectors/ArrowBack";
import CheckmarkAppFilled from "@/assets/vectors/CheckmarkAppFilled";
import ChevronRight from "@/assets/vectors/ChevronRight";
import ListDashHeader from "@/assets/vectors/ListDashHeader";
import Button from "@/components/button/Button";
import Topline from "@/components/topline/Topline";
import CaseStudy from "@/types/CaseStudy";
import dictionary from "@/utils/dictionary";
import styles from "./case_study_conclusion.module.scss";

interface CaseStudyConclusionProps {
    caseStudy: CaseStudy;
}

export default function CaseStudyConclusion({ caseStudy }: CaseStudyConclusionProps) {
    const nextCaseStudy = PROJECTS.filter(it => it.case_study && it.case_study.slug !== caseStudy.slug).map(it => it.case_study)[0];
    return (
        <section
            id="section_conclusion"
            className={styles.container}
        >
            <Topline
                icon={ListDashHeader}
                label={caseStudy.conclusion.title}
                tag="h2"
                data-scroll-animation="come-from-bottom"
            />

            <div
                className={styles.content}
                data-scroll-animation="come-from-bottom"
            >
                <p className={styles.conclusion_text} dangerouslySetInnerHTML={{ __html: caseStudy.conclusion.content }} />

                <div className={styles.takeaways}>
                    <h3 className={styles.takeaways_title}>{dictionary.global.key_takeaways_label}</h3>
                    <ul className={styles.takeaway_list}>
                        {caseStudy.conclusion.key_takeaways.map((takeaway, index) => (
                            <li
                                key={index}
                                className={styles.takeaway}
                            >
                                <CheckmarkAppFilled className={styles.checkmark} />
                                <span dangerouslySetInnerHTML={{ __html: takeaway }} />
                            </li>
                        ))}
                    </ul>
                </div>

                <div className={styles.actions}>
                    <Button
                        label={dictionary.global.back_to_projects}
                        href="/#section_projects"
                        size="large"
                        style="bezeled"
                        startIcon={ArrowBack}
                        iconSize={22}
                    />

                    {nextCaseStudy && (
                        <Button
                            label={dictionary.global.next_case_study}
                            href={`/case-study/${nextCaseStudy.slug}`}
                            size="large"
                            endIcon={ChevronRight}
                            iconSize={12}
                        />
                    )}
                </div>
            </div>
        </section>
    );
}
